import { Howl } from 'howler';

type SoundTypes = 'pop' | 'notification' | 'paid';

const sounds: Record<SoundTypes, Howl> = {
  pop: new Howl({ src: ['/sound/sent.mp3'], volume: 0.4 }),
  notification: new Howl({ src: ['/sound/notification.mp3'], volume: 0.5 }),
  paid: new Howl({ src: ['/sound/paid.mp3'], volume: 0.75 }),
};

export const playSound = (type: SoundTypes) => {
  sounds[type].play();
};

export const playPop = () => playSound('pop');
export const playNotification = () => playSound('notification'); // TODO: use it for incoming messages?...
export const playPaid = () => playSound('paid'); // TODO: use it for incoming messages?...
